import { TranslationKeys as CoreTranslations } from '@pascal/pascal-core';

const GameTranslationKeys = {
  CHACK_HASH_CODE: 'CHACK_HASH_CODE',
  ABOUT_HASH_CODE: 'ABOUT_HASH_CODE',
  ROUND_HASH_CODE: 'FAIRNESS',
  CHECK: 'CHECK',
  resultId: 'ROUND_ID',
  KEY: 'KEY',
  SALT: 'SALT',
  HASH_CODE: 'HASH_CODE',
  HELP: 'HELP',
  lobby: 'LOBBY',
  game: 'GAME',
  bets: 'BETS',
  STATISTICS: 'STATISTIC',
  results: 'RESULTS',
  FairnessModalTitle: 'FAIRNESS',
  ok: 'OK',
  Wait: 'WAIT',
  pleaseWait: 'PLEASE_WAIT',
  connecting: 'CONNECTING',
  autoBet: 'AUTO_BET',
  betsAreClosing: 'BETS_ARE_CLOSING',
  placeYourBets: 'PLACE_YOUR_BETS',
  betsAreClosed: 'BETS_ARE_CLOSED',
  youWin: 'YOU_WIN',
  provablyFairness: 'PROVABLY_FAIRNESS',
  INFO: 'INFO',
  About: 'ABOUT',
  TopWinners: 'TOP_WINNERS',
  History: 'HISTORY',
  Result: 'RESULT',
  LiveBets: 'LIVE_BETS',
  Statistics: 'STATISTICS',
  Bet: 'BET',
  Info: 'INFO',
  ProvablyFairness: 'PROVABLY_FAIRNESS',
  BetForNextRound: 'BET_FOR_NEXT_ROUND',
  Time: 'TIME',
  Stop: 'STOP',
  GameId: 'GAME_ID',
  Count: 'COUNT',
  TotalBet: 'TOTAL_BET',
  Game: 'GAME',
  PlayForReal: 'PLAY_FOR_REAL',
  Music: 'MUSIC',
  Sound: 'SOUND',
  WinterMode: 'WINTER_MODE',
  BlackMode: 'BLACK_MODE',
  PlayerId: 'PLAYER_ID',
  BetType: 'BET_TYPE',
  LastRounds: 'LAST_ROUNDS',
  Balance: 'BALANCE',
  All: 'ALL',
  Win: 'WIN',
  Lose: 'LOSE',
  MaximumWin: 'MAXIMUM_WIN',
  MinimumBet: 'MINIMUM_BET',
  MaximumBet: 'MAXIMUM_BET',
  Seconds: 'SECONDS',
  PlayNow: 'PLAY_NOW',
  Demo: 'DEMO',
  Play: 'PLAY',
  ResultId: 'RESULT_ID',
  Results: 'RESULTS',
  Pf: 'PF',
  Soon: 'SOON',
  Odd: 'ODD',
  Chat: 'CHAT',
  Cancel: 'CANCEL',
  Highest: 'TOP_ODDS',
  CashOut: 'CASHOUT',
  Min: 'MIN',
  Max: 'MAX',
  AllIn: 'ALL_IN',
  AutoBet: 'AUTO_BET',
  Markets: 'MARKETS',
  Ranges: 'RANGES',
  Manual: 'MANUAL',
  GameResult: 'GAME_RESULT',
  Bet_1: 'BET_1',
  Me: 'ME',
  CancelationMessage1: 'CANCELATION_MESSAGE_1',
  MalfunctionMessage2: 'MALFUNCTION_MESSAGE_2',
  Rtp: 'RTP',
  Step: 'STEP',
  FreeBet: 'FREE_BET',
  RoundId: 'ROUND_ID',
  PlaceYourBets: 'PLACE_YOUR_BETS',
  YouWin: 'YOU_WIN',
  MyBets: 'MY_BETS',
  roundId: 'ROUND_ID',
  choseRange: 'CHOOSE_RANGE',
  date: 'DATE',
  odd: 'ODD',
  Odds: 'ODDS',
  Cashed: 'CASHED',
  topGoal: 'TOP_GOAL',
  lastResult: 'LAST_RESULT',
  or: 'OR',
  choseX: 'CHOOSE_X',
  score: 'SCORE',
  upTo: 'UP_TO',
  statistics: 'STATISTICS',
  MaxWinPopUpText: 'MAX_WIN_POP_UP_TEXT',
  FreeBetMaxPayout: 'FREE_BET_MAX_PAYOUT',
  TryAgain: 'TRY_AGAIN',
  NoBet: 'NO_BET',
};

export const globalTranslationKeys = Object.assign(CoreTranslations, GameTranslationKeys);
